export default {
  card1: {
    title: '招聘管理系统',
    desc: '从招聘到入职前的候选人管理',
    useNow: '立即使用',
    lastUsed: '上次使用',
  },
  card2: {
    title: '留任支持系统',
    desc: '外国人才的居留资格及留任管理',
    useNow: '立即使用',
    lastUsed: '上次使用',
  },
  noAccessPermission: '抱歉，您没有访问系统的权限，请联系管理员',
};